<template>
  <o-field
    rootClass="tgbField"
    labelClass="tgbLabel"
    :label="label"
  >
    <o-input
      v-bind="{...$props, ...$attrs}"
      v-on="$listeners"
      @blur="$emit('blur')"
      @change="$emit('change')"
    >
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
    </o-input>
  </o-field>
</template>

<script>
export default {
  name: 'TgbTextbox',
  inheritAttrs: false,
  props: ['label', 'value'],
  computed: {
    innerModel: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
